<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  BModal, BButton, BAlert, BRow, BCol, BFormGroup, BFormCheckbox, AlertPlugin,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import { required, email } from '@validations';
import axios from '@/libs/axios';

export default {
  components: {
    BModal,
    BButton,
    BAlert,
    vSelect,
    BRow,
    BCol,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        workflowid: '',
        workflowdescricao: '',
      }),
      require: true,
    },
    titleModal: {
      type: String,
      default: null,
      require: false,
    },
    idModal: {
      type: String,
      default: null,
      require: false,
    },
    labelBtnOk: {
      type: String,
      default: null,
      require: false,
    },
  },
  data() {
    return {
      dataFromApiWorkflowtipo: null,
    };
  },
  computed: {
    dataForm: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  mounted() {
    this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
      if (modalId === this.idModal) {
        this.onModalShow();
      }
    });
  },
  beforeDestroy() {
    this.$root.$off('bv::modal::show');
  },
  methods: {
    async validateForm() {
      this.$emit('ok', this.dataForm);
      this.$bvModal.hide(this.idModal);
    },
    async fetchDataFromWorkflowtipo() {
      try {
        const response = await axios.get('/workflow-tipo');
        this.dataFromApiWorkflowtipo = response.data.data;
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },
    onModalShow() {
      this.fetchDataFromWorkflowtipo();
    },
  },
};
</script>

<template>
  <b-modal
      ref="modalAtt"
      no-close-on-backdrop
      no-close-on-esc
      size="xl"
      :id="idModal"
      :title="titleModal"
      :ok="dataForm.isDefault || dataForm.workflowdescricao === ''"
      :ok-title="labelBtnOk"
      ok-variant="success"
      cancel-variant="secondary"
      body-bg-variant="light"
      cancel-title="Cancelar"
      @ok="validateForm"
      @cancel="$emit('cancel')"
      @close="$emit('cancel')"
  >
    <validation-observer ref="refFormData">
      <b-form @submit.prevent>
        <b-row>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Descricao"
                label-for="workflowdescricao"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Descrição"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.workflowdescricao"
                    id="workflowdescricao"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Digite a descrição"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Icon"
                label-for="workflowicon"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Descrição"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.workflowicon"
                    id="workflowicon"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Digite a descrição"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Cor"
                label-for="workflowcor"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Descrição"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.workflowcor"
                    id="workflowcor"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Digite a descrição"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Utilização"
                label-for="workflowtipoid"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Descrição"
                  rules="required"
              >
                <b-form-select
                    v-model="dataForm.workflowtipoid"
                    id="workflowtipoid"
                    :state="errors.length > 0 ? false : null"
                    :options="dataFromApiWorkflowtipo"
                    value-field="workflowtipoid"
                    text-field="workflowtipodescricao"
                    placeholder="Selecione uma utilização"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Exibe Frete"
                label-for="workflowexibefrete"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Descrição"
                  rules="required"
              >
                <b-form-checkbox
                    v-model="dataForm.workflowexibefrete"
                    id="workflowexibefrete"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Digite a descrição"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Exibe Va"
                label-for="workflowexibeva"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Descrição"
                  rules="required"
              >
                <b-form-checkbox
                    v-model="dataForm.workflowexibeva"
                    id="workflowexibeva"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Digite a descrição"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Exibe Motivo Sigiloso"
                label-for="workflowexibemotivosigiloso"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Descrição"
                  rules="required"
              >
                <b-form-checkbox
                    v-model="dataForm.workflowexibemotivosigiloso"
                    id="workflowexibemotivosigiloso"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Digite a descrição"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Exibe Info Fiscal"
                label-for="workflowexibeinfofiscal"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Descrição"
                  rules="required"
              >
                <b-form-checkbox
                    v-model="dataForm.workflowexibeinfofiscal"
                    id="workflowexibeinfofiscal"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Digite a descrição"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Exibe Info Comercial"
                label-for="workflowexibeinfocomercial"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Descrição"
                  rules="required"
              >
                <b-form-checkbox
                    v-model="dataForm.workflowexibeinfocomercial"
                    id="workflowexibeinfocomercial"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Digite a descrição"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Exibe Info Financeira"
                label-for="workflowexibeinfofinanceira"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Descrição"
                  rules="required"
              >
                <b-form-checkbox
                    v-model="dataForm.workflowexibeinfofinanceira"
                    id="workflowexibeinfofinanceira"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Digite a descrição"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Preço Minimo"
                label-for="workflowprecominimo"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Descrição"
                  rules="required"
              >
                <b-form-checkbox
                    v-model="dataForm.workflowprecominimo"
                    id="workflowprecominimo"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Digite a descrição"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Prazo Medio"
                label-for="workflowprazomedio"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Descrição"
                  rules="required"
              >
                <b-form-checkbox
                    v-model="dataForm.workflowprazomedio"
                    id="workflowprazomedio"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Digite a descrição"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Exibir Últimas Compras"
                label-for="workflowexibeultimascompras"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Descrição"
                  rules="required"
              >
                <b-form-checkbox
                    v-model="dataForm.workflowexibeultimascompras"
                    id="workflowexibeultimascompras"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Digite a descrição"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Exibir Alteração Pedidos"
                label-for="workflowexibealtpedido"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Descrição"
                  rules="required"
              >
                <b-form-checkbox
                    v-model="dataForm.workflowexibealtpedido"
                    id="workflowexibealtpedido"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Digite a descrição"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-modal>
</template>
